import axios from "../axios";
import { encodeQueryFilter } from "./utils";

const BASE = "/api/masters";
const REGISTRATION_URL = "/registration";
const PRODUCTS_MASTER_URL = "/products";

export function fetchAllMasters() {
  return axios({
    url: `${BASE}${REGISTRATION_URL}`,
    method: "get",
  });
}

export function fetchMasters(url: string, filter?: any) {
  let completeUrl = `${BASE}${url}`;
  if (filter) {
    completeUrl += `?filter=${encodeQueryFilter(filter)}`;
  }
  return axios({
    url: completeUrl,
    method: "get",
  });
}

export function fetchMasterItems(url: string, data: any) {
  let completeUrl = `${BASE}${url}/get-items-by-id`;
  return axios({
    url: completeUrl,
    method: "post",
    data,
  });
}

// Products master
export function fetchProducts(ids: string[]) {
  return fetchMasterItems(PRODUCTS_MASTER_URL, ids);
}
